import { useState, useEffect } from "react";
import { m } from "framer-motion";
import cx from "classnames";

import CircleGrid from "../common/circleGrid";
import ProgressiveImage from "../common/ProgressiveImage";
import style from "../common/circleGrid.module.css";

const PersonalPics = () => {
  const [activePhoto, setActivePhoto] = useState<number | null>(0);
  const [isAnimating, setIsAnimating] = useState(true);

  useEffect(() => {
    const timers = [
      setTimeout(() => setActivePhoto(null), 2200),   // collapse to slices
      setTimeout(() => setActivePhoto(3), 3200),       // expand climbing
      setTimeout(() => setActivePhoto(null), 4200),    // collapse to slices
      setTimeout(() => setActivePhoto(1), 5200),       // expand backcountry
      setTimeout(() => setActivePhoto(null), 6200),    // collapse to slices
      setTimeout(() => setActivePhoto(2), 7200),       // expand family
      setTimeout(() => setActivePhoto(null), 9200),    // collapse to final rest
      setTimeout(() => setIsAnimating(false), 10200),  // enable hover interaction
    ];
    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <>
      <div className="text-center relative mt-12 px-8 w-full mx-auto leading-loose">
        <m.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="font-body"
        >
          You can usually find me at home with my copilot Charlie.
        </m.p>
        <m.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 3.2, duration: 0.8 }}
          className="font-body"
        >
          The rest of the time I try to get out in nature
        </m.p>
        <m.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 7.2, duration: 0.8 }}
          className="font-body"
        >
          and spend time with family.
        </m.p>
      </div>
      <m.div
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{
          duration: 0.6,
          ease: [0, 0.71, 0.2, 1.01],
          scale: {
            type: "spring",
            damping: 10,
            stiffness: 100,
            restDelta: 0.001,
          },
        }}
        className="mx-8 mt-8 relative"
      >
        <CircleGrid className={cx(activePhoto !== null && style.cycling, isAnimating && "pointer-events-none")}>
          <ProgressiveImage
            className={cx(activePhoto === 0 && style.reveal)}
            placeholder="https://live.staticflickr.com/65535/54047278043_fca00d43b7_m.jpg"
            src="https://live.staticflickr.com/65535/54047278043_fca00d43b7_z.jpg"
            alt="charlie"
            loading="lazy"
          />
          <ProgressiveImage
            className={cx(activePhoto === 1 && style.reveal)}
            placeholder="https://live.staticflickr.com/65535/54047470225_2973422061_m.jpg"
            src="https://live.staticflickr.com/65535/54047470225_2973422061_z.jpg"
            alt="backcountry"
            loading="lazy"
          />
          <ProgressiveImage
            className={cx(activePhoto === 2 && style.reveal)}
            placeholder="https://live.staticflickr.com/65535/54047470050_3732bed1f1_t.jpg"
            src="https://live.staticflickr.com/65535/54047470050_3732bed1f1_z.jpg"
            alt="family"
            loading="lazy"
          />
          <ProgressiveImage
            className={cx(activePhoto === 3 && style.reveal)}
            placeholder="https://live.staticflickr.com/65535/54050085531_95f30db987_m.jpg"
            src="https://live.staticflickr.com/65535/54050085531_95f30db987_z.jpg"
            alt="climbing"
            loading="lazy"
          />
        </CircleGrid>
      </m.div>
    </>
  );
};

export default PersonalPics;
